import React, { useState, useEffect } from 'react';
import { getAuth, signOut } from 'firebase/auth';
import { getDatabase, ref, set, onValue, remove } from 'firebase/database';
import { useNavigate } from 'react-router-dom';
import './MyInfo.css';
import PropTypes from 'prop-types';

function MyInfo({ isOpen2, onClose2 }) {
  const [inputValue, setInputValue] = useState('');
  const [myInfo, setMyInfo] = useState('');
  const [savedVideos, setSavedVideos] = useState([]);
  const navigate = useNavigate();

  const handleCancelButtonClick = () => {
    onClose2();
  };

  // 로그인한 사용자 uid 가져오기
  const { currentUser } = getAuth();
  const uid = currentUser ? currentUser.uid : '';

  useEffect(() => {
    if (uid) {
      // Firebase Realtime Database에서 사용자의 MyInfo 가져오기
      const db = getDatabase();
      const myInfoRef = ref(db, `users/${uid}/myInfo`);
      onValue(myInfoRef, (snapshot) => {
        const data = snapshot.val();
        if (data) {
          setMyInfo(data.info);
        }
      });

      // Firebase Realtime Database에서 사용자가 저장한 비디오 가져오기
      const savedVideosRef = ref(db, `users/${uid}/savedVideos`);
      onValue(savedVideosRef, (snapshot) => {
        const data = snapshot.val();
        if (data) {
          setSavedVideos(Object.values(data));
        }
      });
    }
  }, [uid]);

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleSaveButtonClick = () => {
    if (!uid) {
      console.log('로그인한 사용자 정보가 없습니다.');
      return;
    }

    // Firebase Realtime Database에 데이터 저장하기
    const db = getDatabase();
    set(ref(db, `users/${uid}/myInfo`), {
      info: inputValue
    })
      .then(() => {
        console.log('데이터 저장 성공!');
        alert('데이터 저장에 성공하였습니다');
        setInputValue('');
      })
      .catch((error) => {
        console.error('데이터 저장 실패:', error);
      });
  };
  const handleLogoutButtonClick = () => {
    const auth = getAuth();
    signOut(auth)
      .then(() => {
        console.log('로그아웃 성공!');
        // 로그아웃이 성공하면, 홈 화면으로 이동합니다.
        navigate('/');
      })
      .catch((error) => {
        console.error('로그아웃 실패:', error);
      });
  };
  
  const handleCopyTags = (video) => {
    // 비디오 id 추출
    const videoId = video.url.split('v=')[1];

    // YouTube Data API에서 비디오 정보 가져오기
    fetch(`https://www.googleapis.com/youtube/v3/videos?id=${videoId}&part=snippet,contentDetails&key=${myInfo}`)
      .then(response => response.json())
      .then(data => {
        if (data && data.items && data.items.length > 0 && data.items[0].snippet.tags) {
          // 태그 정보 추출
          const tags = data.items[0].snippet.tags;

          // 클립보드 API를 사용하여 태그 복사
          navigator.clipboard.writeText(tags.join(', '))
            .then(() => console.log('태그 복사 성공!'))
            .catch(error => console.error('태그 복사 실패:', error));
        } else {
          console.error('태그 정보를 가져올 수 없습니다.');
        }
      })
      .catch(error => console.error('YouTube Data API 호출 실패:', error));
  };

  const deletebutton = () => {
    if (!uid) {
      console.log('로그인한 사용자 정보가 없습니다.');
      return;
    }

    const db = getDatabase();
    const savedVideosRef = ref(db, `users/${uid}/savedVideos`);

    remove(savedVideosRef)
      .then(() => {
        console.log('savedVideos 데이터 삭제 성공!');
      })
      .catch((error) => {
        console.error('savedVideos 데이터 삭제 실패:', error);
      });
  };

  
  
  


 useEffect(() => {
   if (uid) {
     const db = getDatabase();
     const savedVideosRef = ref(db, `users/${uid}/savedVideos`);
     onValue(savedVideosRef, (snapshot) => {
       const data = snapshot.val();
       if (data) {
         setSavedVideos(Object.values(data));
       }
     });
   }
 }, [uid]);

 return (
  <div className={`modal ${isOpen2 ? 'open' : ''}`}>
   <div className="my-info">
     <div className="my-info-header">
       <h2>My Info</h2>
       <button onClick={handleCancelButtonClick}>닫기</button>
     </div>
     <div className="my-info-content">
       <div className="input-wrapper">
         <label htmlFor="my-info-input">Input your info:</label>
         <input
           id="my-info-input"
           type="text"
           value={inputValue || myInfo}
           onChange={handleInputChange}
         />
       </div>
       <button onClick={handleSaveButtonClick}>저장</button>
       <div className="saved-videos-header">
       <h2>Saved Videos</h2>
       <button className="delete-button" onClick={deletebutton}>비우기</button>
       </div>
       <table>
         <thead>
           <tr>
             <th>Thumbnail</th>
             <th>Title</th>
             <th>Subscribers</th>
             <th>Views</th>
             <th>태그복사</th>
           </tr>
         </thead>
         <tbody>
           {savedVideos.sort((a, b) => b.contribution - a.contribution).map((video, index) => (
             <tr key={index}>
               <td className="video-thumbnail">
                 <a href={video.url} target="_blank" rel="noopener noreferrer">
                   <img src={video.thumbnail} alt={video.title} />
                   </a>
                </td>
                <td className="video-title">{video.title}</td>
                <td>{video.subscribers.toLocaleString()}</td>
                <td>{video.views.toLocaleString()}</td>
                <td>
                  <button onClick={() => handleCopyTags(video)}>태그복사</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
    </div>
  );
}

MyInfo.propTypes = {
  isOpen2: PropTypes.bool.isRequired,
  onClose2: PropTypes.func.isRequired,
};

export default MyInfo;


   
